export enum MenuEnum {
    HOME = '1',
    SEGMENTOS = '2',
    CASES = '3',
    PLATAFORMA_TD = '4',
    REVENDA = '5',
    CONTATO = '6'
}
